import React from 'react';
import './menu-list.style.scss';
import AutoSizer from 'react-virtualized-auto-sizer';
import List from 'react-virtualized/dist/commonjs/List';
import { DishFixed } from '../../../models/fixed/dish.entity';
import { DishListItem, getDishNum } from '../order.component';
import i18n from '../../../i18n';
import _ from 'lodash';
import { Dish, Schedule } from '../../../models';
import { ScrollParams } from 'react-virtualized';

class MenuList extends React.Component<Props, State> {

    public AutoSizerRef: List | null = null;

    constructor(props: Props) {
        super(props);
        this._rowRenderer = this._rowRenderer.bind(this);
    }

    public state: State = {
        selectedIndex: null,
    }
    public projectItem: { [key: number]: number } = {};
    public progress: boolean = false;
    // *********************
    // Life Cycle Function
    // *********************
    componentDidMount() {
    }

    // *********************
    // Default Function
    // *********************


    _rowRenderer({ index, key, style }: any) {

        const item: any = this.props.dishList[index] || {};
        const dishTitle = _.has(item, 'title_name');

        const { number: buyNumber, historyNumber } = getDishNum({ dishItem: item, saveShopCatDate: this.props.saveShopCatDate, orderInfo: {} });
        const collapseRenderer = this.props.collapseRenderer;
        return (
            <div key={key} style={style} >
                {dishTitle ? <h6 className='menu-title-text'>{item.title_name === 'special_dish' ? i18n.t('restaurant_info_page_text_featured_dishes') : item.title_name}</h6> : null}
                {!dishTitle && <DishListItem
                    itemIndex={index}
                    itemData={item}
                    updateShopCatList={(itemData, status) => {
                        this.props.updateShopCatList(itemData, status)
                    }}
                    number={buyNumber}
                    historyNumber={historyNumber}
                    onshowDishDetails={(dishes) => {
                        this.props?.onshowDishDetails?.(dishes, index, this.state.selectedIndex !== index);
                        if (!this.progress && item.dish_type === '4') {
                            this.progress = true;
                            // this.trigger(index);
                            this.setState({
                                selectedIndex: this.state.selectedIndex === index ? null : index,
                            })
                        }
                    }}
                    choosePackageMeal={(itemData: Dish) => { this.props?.choosePackageMeal?.(itemData) }}
                    orderType={this.props.orderType}
                    openSchedulesModel={() => this.props.openSchedulesModel(item.availableSchedule)}
                    collapse={this.state.selectedIndex === index}
                    collapseRenderer={collapseRenderer ? () => collapseRenderer(item, index, this.state.selectedIndex === index) : undefined}
                />}

            </div>)
    }



    trigger(itemIndex: number, isChange?: boolean) {
        const height = document.getElementById(`parkProjectCollapse-${itemIndex}`)?.offsetHeight || 0;
        const closeSelf = isChange ? false : !!this.projectItem[itemIndex];
        const duration = 300; // 动画持续时间（毫秒）
        const startTime = Date.now();
        const startHeight = this.projectItem[itemIndex] || 0;
        const targetHeight = closeSelf ? 0 : height;

        const timer = setInterval(() => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // 使用 easeInOutQuad 缓动函数
            const easeProgress = progress < 0.5
                ? 2 * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 2) / 2;

            this.projectItem[itemIndex] = startHeight + (targetHeight - startHeight) * easeProgress;

            // 关闭其他展开的项
            Object.keys(this.projectItem).forEach((key) => {
                if (key !== `${itemIndex}` && this.projectItem[key]) {
                    const currentHeight = this.projectItem[key];
                    this.projectItem[key] = currentHeight * (1 - easeProgress);
                    if (this.projectItem[key] <= 0) {
                        delete this.projectItem[key];
                    }
                }
            });

            this.recomputeGridSize();

            if (progress >= 1) {
                if (closeSelf) {
                    delete this.projectItem[itemIndex];
                }
                this.progress = false;
                clearInterval(timer);
            }
        }, 16); // 约60fps

    }

    /**
     * 重新计算 GridSize
     */
    recomputeGridSize() {
        this.AutoSizerRef?.recomputeGridSize();
    }

    /**
     * 移动到
     */
    scrollToPosition(scrollTop: number) {
        this.AutoSizerRef?.scrollToPosition(scrollTop);
    }

    // *********************
    // View
    // *********************

    render() {
        const { dishList } = this.props;
        return (
            <div className='order-page-menu-list' id={'order-page-menu-list'}>
                <AutoSizer>
                    {({ width, height }) => (
                        <List
                            containerStyle={{ pointerEvents: 'auto', paddingBottom: '200px' }}
                            ref={refs => { this.AutoSizerRef = refs }}
                            onScroll={this.props.onScroll}
                            height={height}
                            overscanRowCount={1}
                            rowCount={dishList.length}
                            rowHeight={
                                ({ index }) => {
                                    const item = dishList[index];
                                    let height = 0;
                                    if (item && !_.has(item, 'title_name')) {
                                        height = 300 / 1080 * window.innerWidth;
                                    } else {
                                        height = 42;
                                    }
                                    // 获取元素高度
                                    // const element = document.getElementById(`dishListItemBox-${index}`);
                                    // console.log(element, 'element');
                                    height = height + (this.projectItem[index] || 0);
                                    return Number(height.toFixed(2));
                                }
                            }
                            rowRenderer={this._rowRenderer}
                            width={width}
                        />
                    )}
                </AutoSizer>
            </div>
        )
    }
}
export default MenuList

// *********************
// State & Props
// *********************

type State = {
    selectedIndex: number | null;
}

type Props = {
    dishList: DishFixed[];
    updateShopCatList: (itemData: Dish, status: boolean) => void;
    saveShopCatDate: Array<Dish>;
    onshowDishDetails?: (itemData: Dish, index: number, isShow: boolean) => void;
    // 选择套餐、包餐
    choosePackageMeal?: (itemData: Dish) => void;
    onScroll?: ((params: ScrollParams) => any) | undefined
    // 订单详情
    // orderInfo: Order;
    // 订单类型1：自取 2：外送 3：堂食
    orderType: string;
    openSchedulesModel: (dishSchedules: Schedule[]) => void;
    collapseRenderer?: (itemData: Dish, index: number, collapse: boolean) => JSX.Element;
}